// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"DeleteMediaModalContent_modal-wrapper__riO1y"};